import React, { Component } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TitledLabel from '../../controls/TitledLabel'
import GenericModal from '../../widgets/common/GenericModal'
import { localize } from '../../util/Localizer'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import IconButton from '@material-ui/core/IconButton'
import ErrorMessage from '../common/ErrorMessage'
import Tooltip from '../../controls/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import Icon from '@material-ui/core/Icon'
import { Colors } from '../../theme'

class PractitionerRow extends Component {
  constructor () {
    super()
    this.state = { showGenericModal: false }
  }

  render () {
    const newClaim = this.props.newClaim
    let p = this.props.p
    let name = ''
    let phone = ''
    let address = ''
    let city = ''
    let postalCode = ''
    let province = ''
    let elevation = 1
    let checked = false
    if (p) {
      if (p.firstName) {
        name = `${p.firstName} ${p.lastName}`
      } else {
        name = p.clinicName
      }
      phone = p.phone
      address = p.address
      city = p.city
      province = p.province
      postalCode = p.postalCode
      address = `${address}-${city} ${province}`
      elevation = this.props.isSelected === true ? 2 : 1
      checked = this.props.isSelected || false
    } else if (this.props.newClaim) {
      name = this.props.newClaim.clinicName
      phone = this.props.newClaim.phone
      address = `${newClaim.address}-${newClaim.city} ${newClaim.province} - ${newClaim.postalCode}`
      elevation = this.props.practitioner === this.props.newClaim ? 2 : 1
      checked = this.props.practitioner === this.props.newClaim
    }
    const { classes = {} } = this.props
    return (
      <Paper className={this.props.classes.summaryCard} elevation={elevation}>
        {this.state.showGenericModal
          ? <Row>
            <Col xs={12}>
              <GenericModal
                ref={this.genericModal}
                showOk
                handleOk={() => {
                  this.props.delete()
                  this.setState({ showGenericModal: false })
                }}
                handleClose={() => {
                  this.setState({ showGenericModal: false })
                }}
                open={this.state.showGenericModal}
                OkButtonText={localize('yesText')}
                CancelButtonText={localize('noText')}
                modal
                message={localize('pages.SubmitAClaim.PractitionerDeleteWarning')}
              />
            </Col>
          </Row> : null}
        <Row start='xs' >
          <Col xs={1} onClick={this.props.onClick} className={classes.select}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked || false}
                  icon={<Icon style={{ color: Colors.Palette.primaryTextColor }}>check_box_outline_blank</Icon>}
                  checkedIcon={<Icon color='primary'>check_box</Icon>}
                />
              }
            />
          </Col>
          <Col lg={9} xs={12}>
            <Row className={classes.select} onClick={this.props.onClick}>
              <Col {...Columns.max6} style={{ overflowWrap: 'break-word' }}>
                <TitledLabel title='common.name' value={name}/>
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.PhoneNumber' value={phone} />
              </Col>
              <Col xs={9} sm={2} md={2} lg={3}>
                <TitledLabel title='pages.cardDetails.address' value={`${address} - ${postalCode}`} />
              </Col>
              <Col {...Columns.max6} />
            </Row>
          </Col>
          <Col xs={12} lg={2}>
            <Row around='xs' center='xs'>
              {this.props.canDelete &&
                <Col>
                  <Tooltip title={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.DeleteButton')} placement="bottom">
                    <IconButton
                      onClick={() => { this.setState({ showGenericModal: true }) }}
                      className='submitNavButton'
                    >
                      <Icon style={{ color: Colors.Palette.primaryTextColor }}>delete</Icon>
                    </IconButton>
                  </Tooltip>
                </Col>}
              {this.props.edit && <Col>
                <Tooltip title={localize('pages.SubmitAClaim.Expenses.EditButton')} placement="bottom">
                  <IconButton
                    onClick={this.props.edit}
                    className='submitNavButton'
                  >
                    <Icon style={{ color: Colors.Palette.primaryTextColor }}>edit</Icon>
                  </IconButton>
                </Tooltip>
              </Col>}
            </Row>
          </Col>
          {this.props.deleteError
            ? <Col xs={12}>
              <ErrorMessage error={this.props.deleteError} />
            </Col>
            : null}
        </Row>
      </Paper>
    )
  }
}

const styles = {
  ...CardStyles,
  select: {
    cursor: 'pointer'
  }
}

export default withStyles(styles)(PractitionerRow)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/practitionerRow.js